import { render, staticRenderFns } from "./ProductModelCol.vue?vue&type=template&id=35a4e032&scoped=true&"
import script from "./ProductModelCol.vue?vue&type=script&lang=js&"
export * from "./ProductModelCol.vue?vue&type=script&lang=js&"
import style0 from "./ProductModelCol.vue?vue&type=style&index=0&id=35a4e032&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a4e032",
  null
  
)

export default component.exports